'use client';

import { FormEvent, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { ClassNameProps } from '@/types/common.types';

import { PeriodEnum } from '@/enums/subscription-type.enums';

import { Form } from '@/components/Form';

import { useStore } from '@/contexts/StoreContext';

import styles from '@/views/SubscriptionView/PurchasingSubscriptionsView/SelectSubscriptionPeriod.module.scss';

// =================================================================

type SubscriptionDurationFormType = {
  subscriptionDuration: boolean;
};

// =================================================================

export const SelectSubscriptionPeriod = (props: ClassNameProps) => {
  const { className } = props;
  const t = useTranslations('common');

  const { subscriptionPeriod, setSubscriptionPeriod } = useStore(store => store.subscriptionStore);

  const methods = useForm<SubscriptionDurationFormType>({
    defaultValues: {
      subscriptionDuration: Boolean(subscriptionPeriod === PeriodEnum.Year),
    },
    reValidateMode: 'onChange',
  });

  const { watch, setValue, reset } = methods;

  useEffect(() => {
    reset({
      subscriptionDuration: Boolean(subscriptionPeriod === PeriodEnum.Year),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionPeriod]);

  return (
    <FormProvider {...methods}>
      <Form
        className={clsx(styles.labelWrapper, className)}
        onClick={event => event.stopPropagation()}
      >
        <button
          type="button"
          className={clsx(styles.labelText, {
            [styles.active]: !watch('subscriptionDuration'),
          })}
          onClick={() => {
            setSubscriptionPeriod(PeriodEnum.Month);
            setValue('subscriptionDuration', false);
          }}
        >
          {t('perMonth')}
        </button>
        <Form.Checkbox
          name="subscriptionDuration"
          variant="toggle"
          onChange={(event: FormEvent<HTMLInputElement>) => {
            setSubscriptionPeriod(
              (event.target as HTMLInputElement).checked ? PeriodEnum.Year : PeriodEnum.Month,
            );
          }}
        />
        <button
          type="button"
          className={clsx(styles.labelText, {
            [styles.active]: watch('subscriptionDuration'),
          })}
          onClick={() => {
            setSubscriptionPeriod(PeriodEnum.Year);
            setValue('subscriptionDuration', true);
          }}
        >
          {t('perYear')}
        </button>
      </Form>
    </FormProvider>
  );
};
